import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import clsx from 'clsx';

import { AssistantPlanEntryButton } from '../../../data-access';
import './AssistantChatCtaButtonsList.scss';

interface AssistantChatCtaButtonsListProps {
  buttons: AssistantPlanEntryButton[];
  onButtonPress: (buttonId: string) => void;
  disabled?: boolean;
  className?: string;
}

const AssistantChatCtaButtonsList: React.FC<AssistantChatCtaButtonsListProps> = ({
  buttons,
  onButtonPress,
  disabled = false,
  className,
}) => {
  if (!buttons || buttons.length === 0) {
    return null;
  }

  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      gap={0.5}
      mt={1}
      width="100%"
      className={clsx('assistant-chat-cta-buttons-list', className)}
    >
      {buttons.map((button) => {
        return (
          <Button
            key={button.id}
            variant="outlined"
            className={clsx('assistant-chat-cta-buttons-list__button', {
              'assistant-chat-cta-buttons-list__button--disabled': disabled,
            })}
            onClick={() => !disabled && onButtonPress(button.id)}
            disabled={disabled}
          >
            <Typography
              variant="subtitle2"
              className="assistant-chat-cta-buttons-list__button-text"
            >
              {button.text}
            </Typography>
          </Button>
        );
      })}
    </Stack>
  );
};

export default AssistantChatCtaButtonsList;
